<template>
  <DragDialog
    title="选择发布平台"
    :width="600"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel">
    <div class="publish-box">
      <div class="common-form-box">
        <el-form
          class="public-form-primary"
          :model="form"
          :rules="rules"
          label-width="135px"
          ref="form">
          <el-form-item
            label="选择发布位置："
            v-if="isRadioVisible()">
            <div class="common-radio-box radio-primary">
              <el-radio
                v-model="publishWay"
                label="1">
                在目标平台新建一个项目
              </el-radio>
              <el-radio
                v-model="publishWay"
                label="2">
                发布到目标平台现有项目
              </el-radio>
            </div>
          </el-form-item>
          <el-form-item
            label="选择发布平台："
            prop="platformId">
            <div class="common-select-box">
              <el-select
                class="primary-select"
                v-model="form.platformId"
                size="small"
                filterable
                remote
                :remote-method="filterPlatForm"
                :loading="filterLoading"
                :popper-append-to-body="false"
                placeholder="请选择一个发布平台"
                @change="handlePlatFormChange">
                <div v-infinite-scroll="handleScroll">
                  <el-option
                    v-for="(item, index) in platFormList"
                    :key="index"
                    :label="item.name"
                    :value="item.id" />
                </div>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            label="选择项目："
            prop="projId"
            v-if="isProjVisible()">
            <div class="common-select-box">
              <el-select
                class="primary-select"
                size="small"
                filterable
                remote
                :remote-method="filterProj"
                :loading="filterProjLoading"
                :placeholder="getPlaceholder()"
                v-model="form.projId"
                :popper-append-to-body="false"
                @change="handleProjChange">
                <template slot="prefix">
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-search"></i>
                </template>
                <div v-infinite-scroll="handleProjScroll">
                  <el-option
                    v-for="(item, index) in projList"
                    :key="index"
                    :label="item.projName"
                    :value="item.projId" />
                </div>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            label="选择项目所属人："
            prop="projOwnerId"
            v-if="isOwnerVisible()">
            <div class="common-select-box">
              <el-select
                class="primary-select"
                size="small"
                filterable
                remote
                :remote-method="filterOwner"
                :loading="filterOwnerLoading"
                placeholder="请为该项目指定一个所属人"
                v-model="form.projOwnerId"
                :popper-append-to-body="false">
                <template slot="prefix">
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-search"></i>
                </template>
                <div v-infinite-scroll="handleOwnerScroll">
                  <el-option
                    v-for="(item, index) in projOwnerList"
                    :key="index"
                    :label="item.name"
                    :value="item.id" />
                </div>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            label="目录树节点："
            v-if="isFolderVisible()">
            <div class="common-select-box">
              <el-select
                class="primary-select"
                ref="treeSelect"
                size="small"
                :popper-append-to-body="false"
                :value="selectedNode.name">
                <el-option
                  style="height: 100%; padding: 0"
                  value="">
                  <div class="common-tree-box">
                    <el-tree
                      ref="tree"
                      :data="treeData"
                      :props="defaultProps"
                      node-key="id"
                      :expand-on-click-node="false"
                      @node-click="handleNodeClick">
                      <div
                        slot-scope="{ data }"
                        class="custom-node-box">
                        <div class="node-label-box">
                          <div
                            class="node-label text-overflow"
                            :title="data.name">
                            <span>{{ data.name }}</span>
                          </div>
                        </div>
                      </div>
                    </el-tree>
                  </div>
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="description-box">
        <span v-if="getDescription()">
          {{ getDescription() }}
        </span>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'
import {
  platformsService,
  platformsUserListService,
  platformsProjListService,
  platformsProjFolderService,
  publishCheckService,
  publishService,
  batchPublishService
} from '@/service/interface'
export default {
  data() {
    return {
      publishWay: '1',
      form: {
        platformId: undefined,
        projOwnerId: undefined,
        projId: undefined
      },
      filterLoading: false,
      platFormCurrPage: 1,
      filterName: '',
      platFormList: [],

      filterOwnerLoading: false,
      ownerCurrPage: 1,
      filterOwnerName: '',
      projOwnerList: [],

      filterProjLoading: false,
      projCurrPage: 1,
      filterProjName: '',
      projList: [],

      selectedNode: {},
      treeData: [],
      defaultProps: {
        children: 'subNodes',
        label: 'name'
      },
      rules: {
        platformId: [
          {
            required: true,
            message: '请为该项目选择一个发布平台',
            trigger: 'blur'
          }
        ],
        projId: [
          {
            required: true,
            message: this.getPlaceholder(),
            trigger: 'blur'
          }
        ],
        projOwnerId: [
          {
            required: true,
            message: '请为该项目指定一个所属人',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  props: {
    visible: Boolean,
    publishInfo: Object,
    closeDialog: Function
  },
  components: { DragDialog },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initPlatFormList()
      }
    }
  },
  methods: {
    initPlatFormList() {
      this.queryPlatFormList().then(response => {
        let { dataList } = response
        this.platFormList = dataList
      })
    },
    handlePlatFormChange() {
      let { exportDatas } = this.publishInfo
      let projDatas = exportDatas.filter(el => el.exportType === 0)
      this.form.projId = ''
      this.form.projOwnerId = ''
      this.selectedNode = {}

      if (!projDatas.length) {
        this.queryProjList().then(response => {
          let { dataList } = response
          this.projList = dataList
        })
        return
      }

      if (projDatas.length === 1) {
        this.queryOwnerList().then(response => {
          let { dataList } = response
          this.projOwnerList = dataList
        })
        return
      }

      if (projDatas.length === exportDatas.length) {
        this.queryOwnerList().then(response => {
          let { dataList } = response
          this.projOwnerList = dataList

          this.projList = projDatas.map(item => {
            let obj = {
              projName: item.projectName,
              projId: item.projectId
            }
            return obj
          })
        })
        return
      }

      if (projDatas.length > 1 && projDatas.length < exportDatas.length) {
        if (this.publishWay === '1') {
          this.queryOwnerList().then(response => {
            let { dataList } = response
            this.projOwnerList = dataList

            this.projList = projDatas.map(item => {
              let obj = {
                projName: item.projectName,
                projId: item.projectId
              }
              return obj
            })
          })
        } else {
          this.queryProjList().then(response => {
            let { dataList } = response
            this.projList = dataList
          })
        }
        return
      }
    },
    handleProjChange() {
      let { exportDatas } = this.publishInfo
      let isAllDataSets = exportDatas.every(el => el.exportType === 2)
      if (!isAllDataSets) return
      this.form.projOwnerId = ''
      this.selectedNode = {}

      let schemeArray = []
      let formatTypeArray = []

      exportDatas.forEach(item => {
        if (item.exportType === 2) {
          let find = schemeArray.find(el => el === item.scheme)
          if (!find) {
            schemeArray.push(item.scheme)
          }

          let findIndex = formatTypeArray.findIndex(
            el => el === item.formatType
          )
          if (findIndex === -1) {
            formatTypeArray.push(item.formatType)
          }
        }
      })

      if (schemeArray.length > 1 || formatTypeArray.length > 1) {
        this.$message.warning('批量发布只支持一种数据类型')
        return
      }

      this.queryProjFolder(schemeArray[0], formatTypeArray[0]).then(
        response => {
          this.selectedNode = {}
          this.treeData = response
        }
      )
    },
    handleNodeClick(nodeData) {
      if (nodeData.id === this.selectedNode.id) return

      this.$refs.tree.setCurrentKey(nodeData.id)
      this.selectedNode = nodeData

      this.$refs.treeSelect.visible = false
    },
    submit() {
      this.$refs.form.validate(bool => {
        if (bool) {
          let exportIds = this.getExportIds()
          this.publishCheck(exportIds).then(checkResult => {
            this.handleExceptionFiles(checkResult, exportIds).then(
              validExportIds => {
                if (validExportIds.length) {
                  let publishParams = this.getPublishParams(validExportIds)
                  if (publishParams.exportId) {
                    publishService(publishParams).then(response => {
                      if (response.isSuccess) {
                        this.cancel()
                      } else {
                        this.$message.error(response.errMsg)
                      }
                    })
                  } else {
                    batchPublishService(publishParams).then(response => {
                      if (response.isSuccess) {
                        this.cancel()
                      } else {
                        this.$message.error(response.errMsg)
                      }
                    })
                  }
                }
              }
            )
          })
        } else {
          this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
        }
      })
    },
    publishCheck(exportIds) {
      return new Promise(resolve => {
        let params = this.getCheckParams(exportIds)
        publishCheckService(params).then(response => {
          let jumpFiles = []
          let overwriteFiles = []

          if (response.isSuccess) {
            let data = response.data
            let { unEffectiveItems, acknowledgedItems } = data
            if (unEffectiveItems) {
              unEffectiveItems.forEach(item => {
                let find = jumpFiles.find(
                  el =>
                    el.exportType === item.exportType &&
                    el.errorMsg === item.errorMsg
                )
                if (find) {
                  find.files.push({ id: item.id, fileName: item.fileName })
                } else {
                  let obj = {
                    exportType: item.exportType,
                    errorMsg: item.errorMsg,
                    files: [{ id: item.id, fileName: item.fileName }]
                  }
                  jumpFiles.push(obj)
                }
              })
            }

            if (acknowledgedItems) {
              acknowledgedItems.forEach(item => {
                let find = overwriteFiles.find(
                  el => el.exportType === item.exportType
                )
                if (find) {
                  find.files.push({ id: item.id, fileName: item.fileName })
                } else {
                  let obj = {
                    exportType: item.exportType,
                    files: [{ id: item.id, fileName: item.fileName }]
                  }
                  overwriteFiles.push(obj)
                }
              })
            }

            resolve({ jumpFiles, overwriteFiles })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    handleExceptionFiles(exceptionFile, exportIds) {
      return new Promise(resolve => {
        let { jumpFiles, overwriteFiles } = exceptionFile

        if (!jumpFiles.length && !overwriteFiles.length) {
          resolve(exportIds)
          return
        }

        let find = jumpFiles.find(el => el.exportType === 0)
        if (find) {
          this.$confirm(find.errorMsg, '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            showClose: false
          }).then(() => {
            this.cancel()
            resolve([])
          })
          return
        }

        let invalidIds = []
        let msgTips = []
        let msgTail = ''
        let dataTypeNames = ['项目信息', '场景', '数据集']
        jumpFiles.forEach(item => {
          let ids = item.files.map(el => el.id)
          invalidIds = [...invalidIds, ...ids]
          msgTips.push(`${item.files.length}个${item.errorMsg}`)
        })
        if (msgTips.length > 1) {
          msgTips = msgTips.map((item, index) => {
            return `${index + 1}、${item}`
          })
        }

        if (!jumpFiles.length) {
          let msgArray = []
          overwriteFiles = overwriteFiles.sort(
            (obj1, obj2) => obj1.exportType - obj2.exportType
          )
          overwriteFiles.forEach(item => {
            if (item.exportType === 0) {
              msgArray.push('项目信息已存在')
            } else {
              let msg = `${item.files.length}个${
                dataTypeNames[item.exportType]
              }在当前项目中已存在`
              msgArray.push(msg)
            }
          })
          let warningMsg = `${msgArray.join('、')},是否覆盖`
          this.$confirm(warningMsg, '提示', {
            iconClass: 'null',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              resolve(exportIds)
            })
            .catch(() => {
              this.cancel()
              resolve([])
            })
          return
        }

        if (this.isAllJumpFiles(exportIds, jumpFiles)) {
          let message = this.createHtml(msgTips, msgTail)
          this.$confirm(message, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            showCancelButton: false,
            showClose: false
          }).then(() => {
            this.cancel()
            resolve([])
          })
          return
        } else {
          if (overwriteFiles.length) {
            let msgArray = []
            overwriteFiles = overwriteFiles.sort(
              (obj1, obj2) => obj1.exportType - obj2.exportType
            )
            overwriteFiles.forEach(item => {
              if (item.exportType === 0) {
                msgArray.push('已存在的项目信息')
              } else {
                let msg = `在当前项目中已存在的${item.files.length}个${
                  dataTypeNames[item.exportType]
                }`
                msgArray.push(msg)
              }
            })
            let msgTail = `是否跳过继续发布，并对${msgArray.join('、')}进行覆盖`
            let message = this.createHtml(msgTips, msgTail)
            this.$confirm(message, '提示', {
              dangerouslyUseHTMLString: true,
              iconClass: 'null',
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                invalidIds.forEach(item => {
                  let findIndex = exportIds.findIndex(el => item === el)
                  if (findIndex !== -1) {
                    exportIds.splice(findIndex, 1)
                  }
                })
                resolve(exportIds)
              })
              .catch(() => {
                this.cancel()
                resolve([])
              })
            return
          } else {
            let message = this.createHtml(msgTips, '是否跳过继续发布')
            this.$confirm(message, '提示', {
              dangerouslyUseHTMLString: true,
              iconClass: 'null',
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                invalidIds.forEach(item => {
                  let findIndex = exportIds.findIndex(el => item === el)
                  if (findIndex !== -1) {
                    exportIds.splice(findIndex, 1)
                  }
                })
                resolve(exportIds)
              })
              .catch(() => {
                this.cancel()
                resolve([])
              })
          }
        }
      })
    },
    isAllJumpFiles(exportIds, jumpFiles) {
      let count = 0
      jumpFiles.forEach(item => {
        count += item.files.length
      })
      if (count === exportIds.length) {
        return true
      } else {
        return false
      }
    },
    cancel() {
      this.publishWay = '1'
      this.form = {
        platformId: undefined,
        projOwnerId: undefined,
        projId: undefined
      }

      this.platFormCurrPage = 1
      this.platFormList = []
      this.ownerCurrPage = 1
      this.projOwnerList = []
      this.projCurrPage = 1
      this.projList = []
      this.selectedNode = {}

      this.closeDialog()
    },
    getExportIds() {
      let { exportDatas } = this.publishInfo
      let projDatas = exportDatas.filter(el => el.exportType === 0)
      let exportIds = []

      if (projDatas.length <= 1) {
        exportIds = exportDatas.map(item => item.id)
      } else {
        let projInfo = exportDatas.find(el => el.projectId === this.form.projId)
        if (projInfo && this.publishWay === '1') {
          exportIds.push(projInfo.id)
        }
        exportDatas.forEach(item => {
          if (item.exportType !== 0) {
            exportIds.push(item.id)
          }
        })
      }

      return exportIds
    },
    getCheckParams(exportIds) {
      let { exportDatas } = this.publishInfo
      let projDatas = exportDatas.filter(el => el.exportType === 0)
      let checkParams = {
        publishPlatformId: this.form.platformId,
        exportIds
      }

      if (!projDatas.length) {
        checkParams.targetProjectId = this.form.projId
        let find = this.projList.find(el => el.projId === this.form.projId)
        checkParams.targetProjectName = find.projName
        checkParams.targetOwnerId = find.creatorId
        checkParams.targetOwnerName = find.creatorName
        return checkParams
      }

      if (projDatas.length === 1) {
        let projInfo = projDatas[0]
        checkParams.targetProjectId = projInfo.projectId
        checkParams.targetProjectName = projInfo.projectName
        checkParams.targetOwnerId = this.form.projOwnerId
        let find = this.projOwnerList.find(
          el => el.id === this.form.projOwnerId
        )
        checkParams.targetOwnerName = find.name
        return checkParams
      }

      if (projDatas.length > 1 && projDatas.length === exportDatas.length) {
        let projInfo = exportDatas.find(el => el.projectId === this.form.projId)
        checkParams.targetProjectId = projInfo.projectId
        checkParams.targetProjectName = projInfo.projectName
        checkParams.targetOwnerId = this.form.projOwnerId
        let find = this.projOwnerList.find(
          el => el.id === this.form.projOwnerId
        )
        checkParams.targetOwnerName = find.name
        return checkParams
      }

      if (projDatas.length > 1 && projDatas.length < exportDatas.length) {
        if (this.publishWay === '1') {
          let projInfo = exportDatas.find(
            el => el.projectId === this.form.projId
          )
          checkParams.targetProjectId = projInfo.projectId
          checkParams.targetProjectName = projInfo.projectName
          checkParams.targetOwnerId = this.form.projOwnerId
          let find = this.projOwnerList.find(
            el => el.id === this.form.projOwnerId
          )
          checkParams.targetOwnerName = find.name
          return checkParams
        } else {
          checkParams.targetProjectId = this.form.projId
          let find = this.projList.find(el => el.projId === this.form.projId)
          checkParams.targetProjectName = find.projName
          checkParams.targetOwnerId = find.creatorId
          checkParams.targetOwnerName = find.creatorName

          return checkParams
        }
      }
    },
    getPublishParams(validExportIds) {
      let { exportDatas } = this.publishInfo
      let projDatas = exportDatas.filter(el => el.exportType === 0)
      let publishParams = {
        publishPlatformId: this.form.platformId
      }

      if (!projDatas.length) {
        publishParams.targetProjectId = this.form.projId
        let find = this.projList.find(el => el.projId === this.form.projId)
        publishParams.targetProjectName = find.projName
        publishParams.targetOwnerId = find.creatorId
        publishParams.targetOwnerName = find.creatorName
      }

      if (projDatas.length === 1) {
        let projInfo = projDatas[0]
        publishParams.targetProjectId = projInfo.projectId
        publishParams.targetProjectName = projInfo.projectName
        publishParams.targetOwnerId = this.form.projOwnerId
        let find = this.projOwnerList.find(
          el => el.id === this.form.projOwnerId
        )
        publishParams.targetOwnerName = find.name
      }

      if (projDatas.length > 1 && projDatas.length === exportDatas.length) {
        let projInfo = exportDatas.find(el => el.projectId === this.form.projId)
        publishParams.targetProjectId = projInfo.projectId
        publishParams.targetProjectName = projInfo.projectName
        publishParams.targetOwnerId = this.form.projOwnerId
        let find = this.projOwnerList.find(
          el => el.id === this.form.projOwnerId
        )
        publishParams.targetOwnerName = find.name
      }

      if (projDatas.length > 1 && projDatas.length < exportDatas.length) {
        if (this.publishWay === '1') {
          let projInfo = exportDatas.find(
            el => el.projectId === this.form.projId
          )
          publishParams.targetProjectId = projInfo.projectId
          publishParams.targetProjectName = projInfo.projectName
          publishParams.targetOwnerId = this.form.projOwnerId
          let find = this.projOwnerList.find(
            el => el.id === this.form.projOwnerId
          )
          publishParams.targetOwnerName = find.name
        } else {
          publishParams.targetProjectId = this.form.projId
          let find = this.projList.find(el => el.projId === this.form.projId)
          publishParams.targetProjectName = find.projName
          publishParams.targetOwnerId = find.creatorId
          publishParams.targetOwnerName = find.creatorName
        }
      }

      if (validExportIds.length === 1) {
        publishParams.exportId = validExportIds[0]
        publishParams.targetNodeId = this.selectedNode.id
      } else {
        publishParams.targetNodeId = this.selectedNode.id
        publishParams.exportIds = validExportIds
      }

      return publishParams
    },
    isRadioVisible() {
      let { exportDatas } = this.publishInfo
      if (exportDatas) {
        let projDatas = exportDatas.filter(el => el.exportType === 0)
        if (projDatas.length > 1 && projDatas.length < exportDatas.length) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isProjVisible() {
      let { exportDatas } = this.publishInfo
      let visible = false
      if (exportDatas) {
        let projDatas = exportDatas.filter(el => el.exportType === 0)
        if (!projDatas.length) {
          visible = true
        }

        if (projDatas.length > 1) {
          visible = true
        }
      }

      return visible
    },
    isOwnerVisible() {
      let { exportDatas } = this.publishInfo
      if (exportDatas) {
        let projDatas = exportDatas.filter(el => el.exportType === 0)
        if (projDatas.length && this.publishWay !== '2') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isFolderVisible() {
      let { exportDatas } = this.publishInfo

      if (exportDatas) {
        let isAllDataSets = exportDatas.every(el => el.exportType === 2)
        if (!isAllDataSets) return false

        let schemeArray = []
        exportDatas.forEach(item => {
          let find = schemeArray.find(el => el === item.scheme)
          if (!find) {
            schemeArray.push(item.scheme)
          }
        })

        if (schemeArray.length === 1) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getPlaceholder() {
      let placeholder = '请在发布平台选择一个项目'
      let { exportDatas } = this.publishInfo
      if (exportDatas) {
        let projDatas = exportDatas.filter(el => el.exportType === 0)
        if (projDatas.length > 1 && projDatas.length === exportDatas.length) {
          placeholder = '请从已选项目中选择一个项目'
        }

        if (projDatas.length > 1 && projDatas.length < exportDatas.length) {
          if (this.publishWay === '1') {
            placeholder = '请从已选项目中选择一个项目'
          }
        }
      }

      return placeholder
    },
    getDescription() {
      let { exportDatas } = this.publishInfo
      let description = ''
      if (exportDatas) {
        let projDatas = exportDatas.filter(el => el.exportType === 0)
        if (projDatas.length === 1) {
          if (projDatas.length === exportDatas.length) {
            description = '【注】系统将在该发布平台新建一个同名项目'
          } else {
            description =
              '【注】系统将在该发布平台新建一个同名项目，并将所选的数据集或场景一并导入到该项目下'
          }
        }

        if (projDatas.length > 1 && projDatas.length === exportDatas.length) {
          description =
            '【注】批量发布只允许选择一个项目信息，请在选择项目一栏进行确认，系统将在该发布平台新建一个同名项目'
        }

        if (projDatas.length > 1 && projDatas.length < exportDatas.length) {
          if (this.publishWay === '1') {
            description =
              '【注】批量发布只允许选择一个项目信息，请在选择项目一栏进行确认，系统将在该发布平台新建一个同名项目，并将已选的数据集或场景导入到该项目内'
          } else {
            description =
              '【注】已选的数据集或场景将被导入到发布平台的该项目内，已选的项目信息将被过滤掉'
          }
        }
      }

      return description
    },
    handleScroll() {
      if (this.allPlatformLoaded) return
      this.platFormCurrPage++
      this.queryPlatFormList().then(response => {
        let { dataList } = response
        if (dataList.length) {
          this.platFormList = [...this.platFormList, ...dataList]
        } else {
          this.allPlatformLoaded = true
        }
      })
    },
    filterPlatForm(filterName) {
      this.platFormCurrPage = 1
      this.allPlatformLoaded = false
      this.filterName = filterName

      this.filterLoading = true
      this.queryPlatFormList().then(response => {
        let { dataList } = response
        this.platFormList = dataList
        this.filterLoading = false
      })
    },
    handleProjScroll() {
      let { exportDatas } = this.publishInfo
      let projDatas = exportDatas.filter(el => el.exportType === 0)
      if (projDatas.length === exportDatas.length) return
      if (projDatas.length > 1 && this.publishWay === '1') return

      if (this.allProjLoaded) return
      this.projCurrPage++
      this.queryProjList().then(response => {
        let { dataList } = response
        if (dataList.length) {
          this.projList = [...this.projList, ...dataList]
        } else {
          this.allProjLoaded = true
        }
      })
    },
    filterProj(filterName) {
      let { exportDatas } = this.publishInfo
      let projDatas = exportDatas.filter(el => el.exportType === 0)
      if (projDatas.length === exportDatas.length) {
        let projList = []
        projDatas.forEach(item => {
          if (item.projectName.includes(filterName)) {
            let obj = {
              projName: item.projectName,
              projId: item.projectId
            }
            projList.push(obj)
          }
        })
        this.projList = projList
        return
      }
      if (projDatas.length > 1 && this.publishWay === '1') {
        let projList = []
        projDatas.forEach(item => {
          if (item.projectName.includes(filterName)) {
            let obj = {
              projName: item.projectName,
              projId: item.projectId
            }
            projList.push(obj)
          }
        })
        this.projList = projList
        return
      }

      this.projCurrPage = 1
      this.allProjLoaded = false
      this.filterProjName = filterName

      this.filterProjLoading = true
      this.queryProjList().then(response => {
        let { dataList } = response
        this.projList = dataList
        this.filterProjLoading = false
      })
    },
    handleOwnerScroll() {
      if (this.allOwnerLoaded) return
      this.ownerCurrPage++
      this.queryOwnerList().then(response => {
        let { dataList } = response
        if (dataList.length) {
          this.projOwnerList = [...this.projOwnerList, ...dataList]
        } else {
          this.allOwnerLoaded = true
        }
      })
    },
    filterOwner(filterName) {
      this.ownerCurrPage = 1
      this.allOwnerLoaded = false
      this.filterOwnerName = filterName

      this.filterOwnerLoading = true
      this.queryOwnerList().then(response => {
        let { dataList } = response
        this.projOwnerList = dataList
        this.filterOwnerLoading = false
      })
    },
    queryPlatFormList() {
      return new Promise(resolve => {
        let params = {
          resultCount: 50,
          skipCount: (this.platFormCurrPage - 1) * 50,
          name: this.filterName
        }
        platformsService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataList = data.items
            if (data.totalCount < 50) {
              this.allPlatformLoaded = true
            }
            dataList = dataList.filter(el => el.liveStatus && el.status)
            resolve({ dataList })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    queryProjList() {
      return new Promise(resolve => {
        let params = {
          resultCount: 50,
          skipCount: (this.projCurrPage - 1) * 50,
          platformId: this.form.platformId,
          projName: this.filterProjName
        }
        platformsProjListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataList = data.items
            if (data.totalCount < 50) {
              this.allProjLoaded = true
            }
            resolve({ dataList })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    queryOwnerList() {
      return new Promise(resolve => {
        let params = {
          resultCount: 50,
          skipCount: (this.ownerCurrPage - 1) * 50,
          platformId: this.form.platformId,
          userName: this.filterOwnerName
        }
        platformsUserListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataList = data.items
            if (data.totalCount < 50) {
              this.allOwnerLoaded = true
            }
            resolve({ dataList })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    queryProjFolder(scheme, formatType) {
      return new Promise(resolve => {
        let params = {
          platformId: this.form.platformId,
          scheme,
          projId: this.form.projId
        }
        if (scheme === 'Bim') {
          params.formatType = formatType
        }
        platformsProjFolderService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            resolve([data])
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getExceptionMsg(fileNames, msgTail) {
      let message = ''
      // 超过两个文件只展示前两个
      if (fileNames.length > 2) {
        let msgHeader = `${fileNames[0]}、${fileNames[1]}等${fileNames.length}个文件`
        message = `${msgHeader}${msgTail}`
      } else {
        message = `${fileNames[0]}${msgTail}`
      }
      return message
    },
    createHtml(msgTips, msgTail) {
      let htmlString = '<div>'
      msgTips.forEach(item => {
        htmlString += `<p>${item}</p>`
      })
      htmlString += `<p>${msgTail}</p>`
      htmlString += '</div>'
      return htmlString
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.publish-box {
  .common-radio-box {
    margin-top: 12px;
  }

  .common-select-box {
    .el-select {
      width: 100%;
    }
  }

  .description-box {
    margin-top: 5px;
    margin-left: 20px;
    text-align: left;
    color: var(--base-border-dark-color12);
    font-size: 13px;
  }
}
</style>
